export default __webpack_public_path__ + "static/illustration-analyze-66dba349f73dfbd3605506302a644be2.png";